// extracted by mini-css-extract-plugin
module.exports = {"mainButton":"InvoiceDetailsHeader_mainButton__15A35"};